import React from 'react';

const BodyWrapper = ({ children }) => (
  <div className="min-vh-100">
    <main className="w-100 min-vh-100">{children}</main>
  </div>
);

export default BodyWrapper;
